module.exports = __webpack_public_path__ + "static/Mindfulness-3-83e163dbcff549a86370b07ec081638f.png";